<div class="mt-32 pagination__block">
  <button
    *ngIf="pagination.countLoaded < pagination.limitCountMaxRows"
    type="button"
    class="button pagination__block-button"
    id="appPaginationPlot"
    (click)="onLoadPartialHandler()"
  >
    Показать еще
    {{ pagination.limitSelected }}
    записей ({{ pagination.limitCountMaxRows - pagination.countLoaded }} из {{ pagination.limitCountMaxRows }})
  </button>
  <div class="pagination__block-list">
    <div class="grid">
      <div class="grid__box grid__box--size-min">Показывать по:</div>
      <div class="grid__box grid__box--size-min" *ngFor="let count of pagination.limits">
        <span
          [ngClass]="{
            'link link--dotted-gray-dark': count != pagination.limitSelected
          }"
          (click)="onChangePaginationLimit(count)"
        >
          {{ count }}
        </span>
      </div>
    </div>
  </div>
</div>
